import React, { Component } from 'react';
import { connect } from 'react-redux';

import { createSupplier } from '../actions/SupplierActions';

import { Pane, Heading, Button } from 'evergreen-ui';
import InfoBlock from '../../common/InfoBlock/InfoBlock';

import { Link } from 'react-router-dom';
import SupplierForm from '../components/SupplierForm';

import Configuration from '../Config';

const validation = Configuration.Validations.supplier;
const defaultValues = Configuration.Defaults.createSupplier;
const mapValidationErrors = Configuration.ErrorHandler.mapValidationErrors;

class CreateSupplier extends Component {

    componentDidMount() {
       
    }

    handleSave = (values) => {
        this.props.dispatch(createSupplier(values));
    }

    render() {
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/suppliers">
                            <Button iconBefore="arrow-left" intent="none">
                                Inapoi la lista furnizori
                            </Button>
                        </Link>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Furnizor nou
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <InfoBlock flex="1">
                        <SupplierForm 
                            isEdit={false}
                            initialValues={defaultValues}
                            validationSchema={validation}
                            onSave={this.handleSave}
                            errors={this.props.errors}/>
                    </InfoBlock>
                </Pane>

            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        errors: state.suppliers.errors.type === 'validation' ? mapValidationErrors(state.suppliers.errors.fields): [],
    }
}

export default connect(mapStateToProps)(CreateSupplier);